import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=891b0a10&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=891b0a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891b0a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('891b0a10')) {
      api.createRecord('891b0a10', component.options)
    } else {
      api.reload('891b0a10', component.options)
    }
    module.hot.accept("./_id.vue?vue&type=template&id=891b0a10&scoped=true&", function () {
      api.rerender('891b0a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/job-request/views/_id.vue"
export default component.exports